import React, { useCallback, useEffect } from 'react'
import { Route, Switch, useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

// Actions
import { logout } from 'store/modules/auth'

// Const
import { EVENT_401, EVENT_503, EVENT_LOCATION_CHANGE } from 'constants/events'
import { PATH_EXPIRED, PATH_LOGIN } from 'routes/paths'

// Services
import event from 'services/event'
import loadingService from 'services/loading'

// Use
import { useIdleTimer } from 'react-idle-timer'

// Routes
import routes from 'routes'

import Gateway from 'Gateway'

// Notifications slice
import { fetchNotifications } from 'store/modules/notifications'

export const App = () => {
  const history = useHistory()
  const location = useLocation()

  // State
  const user = useSelector((state) => state.auth.user)

  // Dispatch
  const dispatch = useDispatch()

  // Get list notifications
  useEffect(() => {
    if (user && user.email) {
      dispatch(fetchNotifications())
    }
  }, [dispatch, user])

  // On 401
  const onEvent401 = useCallback(() => {
    if (user && user.email) {
      history.replace(PATH_EXPIRED)
    } else {
      history.replace(PATH_LOGIN)
    }
  }, [history, user])

  const onEvent503 = useCallback(() => {
    // eslint-disable-next-line no-console
    console.log('TODO: process on maintaince mode')
  }, [])

  // Listen events
  useEffect(() => {
    event.on(EVENT_401, onEvent401)
    event.on(EVENT_503, onEvent503)

    return () => {
      event.off(EVENT_401, onEvent401)
      event.off(EVENT_503, onEvent503)
    }
  }, [onEvent401, onEvent503])

  // Idle case
  const onIdle = async () => {
    if (user && user.email) {
      try {
        loadingService.show()
        await dispatch(logout())
      } catch (error) {
        //
      } finally {
        history.replace(PATH_EXPIRED)
        loadingService.hide()
      }
    }
  }

  // Location change
  useEffect(() => {
    event.emit(EVENT_LOCATION_CHANGE)
  }, [location])

  useIdleTimer({
    onIdle,
    timeout: 1000 * 60 * 15,
    debounce: 500,
  })

  return (
    <Switch>
      {routes.map((route, index) => {
        if (route.guard) {
          return <Gateway key={index} {...route} />
        }

        return <Route key={index} {...route} />
      })}
    </Switch>
  )
}

export default App
